import axios from 'axios';

const api = '/api/payment-payed-types';

export const getAllPaymentPayedTypes = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};
